module.exports = __webpack_public_path__ + "img/hand-right-bottom.3d55b370.png";